const errorMessage = {
  REQUIRED: "This field is required.",
  PATTERN: "Invalid characters used.",
  PHONE_PATTERN: "Invalid number used"
};

export default errorMessage;
